
import { mapState, mapMutations } from "vuex";

export default {
  layout: "white",
  head() {
    return {
      title: this.category.metaTitle,
      description: this.category.metaDescription,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.category.metaDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.category.keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.category.metaTitle || this.data.metaTitle,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.imageUrl,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.imageAlt,
        },
        { hid: "og:image:width", property: "og:image:width", content: 105 },
        { hid: "og:image:height", property: "og:image:height", content: 43 },
        {
          hid: "og:description",
          property: "og:description",
          content: this.category.metaDescription || this.data.metaDescription,
        },
        { hid: "robots", name: "robots", content: this.$config.robots_tag },
      ],
      script: [
        {
          json: {
            "@context": "https://schema.org",
            "@type": "Website",
            url: this.$nuxt.$route.path,
            name: this.data.schemaJson,
          },
          type: "application/ld+json",
        },
      ],
    };
  },
  data() {
    return {
      imageUrl:
        "https://agily.twic.pics/uploads/logo_agily_blanc_1_666eeb020b.svg?twic=v1/output=webp",
      imageAlt: "logo Agily",
    };
  },
  computed: {
    ...mapState("blog", {
      blogTags: (state) => state.blogTags.data,
      category: (state) => state.category.data,
    }),
  },
  async asyncData({ app, $strapi, params, store }) {
    const data = await $strapi.find(`articles/${params._category}`);
    const category = await $strapi.find(`articles-categories?slug=${params._category}`);

    store.dispatch("blog/getBlogTags", {
      itemsPerPage: 12,
      category: params._category,
    });

    return { data: data, category: category[1] };
  },
  methods: {
    ...mapMutations("blog", ["GET_CATEGORY"]),
  },
};
